var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 2.24253C13.4747 1.72983 13.4747 0.897217 13.0004 0.384521C12.526 -0.128174 11.7557 -0.128174 11.2814 0.384521L6.07134 6.02007L3.89322 3.66577C3.41889 3.15308 2.64858 3.15308 2.17425 3.66577C1.69992 4.17847 1.69992 5.01108 2.17425 5.52378L5.20996 8.80503C5.68429 9.31773 6.4546 9.31773 6.92893 8.80503L13.0004 2.24253ZM16.6432 7.49253C17.1176 6.97983 17.1176 6.14722 16.6432 5.63452C16.1689 5.12183 15.3986 5.12183 14.9242 5.63452L6.07134 15.2076L2.07179 10.8886C1.59746 10.3759 0.827148 10.3759 0.352818 10.8886C-0.121512 11.4013 -0.121512 12.2339 0.352818 12.7466L5.20996 17.9966C5.68429 18.5093 6.4546 18.5093 6.92893 17.9966L16.6432 7.49663V7.49253Z",
    fill: "#39C46E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/check-double.a9d6779d8e8646e243c5b46549c18b02.svg";
export { ForwardRef as ReactComponent };